import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { Table } from "antd"
import sortBy from "lodash.sortby"

import { IndexBatchFilesOutputShape } from "@api/services/backstage"
import { IndexTransactionsOutputShape } from "@api/services/transactions"

import useColumns from "./helpers/useColumns"
import { InvestmentShape } from "../shapes"
import InvestmentAttachmentsTable from "./InvestmentAttachmentsTable"


const InvestmentsTransferTable = ({
  sourceProjectId = undefined,
  getSourceBatchName,
  sourceFiles,
  sourceInvestments,
  sourceTransactions,
  getTargetBatchName,
  targetFiles,
  targetInvestments,
  targetTransactions,
}) => {
  const columns = useColumns({
    sourceProjectId,
    sourceFiles,
    targetFiles,
    sourceInvestments,
    targetInvestments,
    sourceTransactions,
    targetTransactions,
  })

  const dataSource = useMemo(() =>
    sortBy([...sourceInvestments, ...targetInvestments], 'investorAccountId')
  , [
    sourceInvestments,
    targetInvestments,
  ])

  const expandedRowRender = (investment) => {
    const { id, projectId } = investment

    const isSourceInvestment = projectId === sourceProjectId

    if (!isSourceInvestment) {
      return (
        <InvestmentAttachmentsTable
          files={targetFiles}
          transactions={targetTransactions}
          investmentId={id}
          getBatchName={getTargetBatchName}
        />
      )
    }

    return (
      <InvestmentAttachmentsTable
        files={sourceFiles}
        transactions={sourceTransactions}
        investmentId={id}
        getBatchName={getSourceBatchName}
      />
    )
  }

  const tableProps = {
    size: "middle",
    rowKey: "id",
    pagination: false,
    expandable: { expandedRowRender },
    columns,
    dataSource
  }

  return (
    <Table {...tableProps} />
  )
}

InvestmentsTransferTable.propTypes = {
  sourceProjectId: PropTypes.string,
  getSourceBatchName: PropTypes.func.isRequired,
  sourceFiles: PropTypes.arrayOf(IndexBatchFilesOutputShape).isRequired,
  sourceInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
  sourceTransactions: PropTypes.arrayOf(IndexTransactionsOutputShape).isRequired,
  getTargetBatchName: PropTypes.func.isRequired,
  targetFiles: PropTypes.arrayOf(IndexBatchFilesOutputShape).isRequired,
  targetInvestments: PropTypes.arrayOf(InvestmentShape).isRequired,
  targetTransactions: PropTypes.arrayOf(IndexTransactionsOutputShape).isRequired,
}

export default InvestmentsTransferTable
